export default __webpack_public_path__ + "static/media/DailyBonus_Pop.c56b81ec.mp3";